<template>
  <div
    class="animate-pulse bg-gray-300/70 rounded"
    :class="[rounded, extra]"
    :style="{ width: w, height: h }"
  ></div>
</template>

<script setup>
defineProps({
  w: { type: String, default: '100%' },
  h: { type: String, default: '1rem' },
  rounded: { type: String, default: 'rounded' },
  extra: { type: String, default: '' },
})
</script>
